import designTokens from './design-tokens-export.scss';

const result = Object.assign({}, designTokens);
Object.keys(result).forEach(key => {
	result[key] = parseValue(result[key]);
});
export default result;

function parseValue(value) {
	const match = /^([\d.]+)(s|ms|px)?$/.exec(value);

	if (!match) {
		return value;
	}

	const [, numberString, unit] = match;
	value = parseFloat(numberString);

	if (unit === 's') {
		value = value * 1000;
	}

	return value;
}
